
//DAta in textboxes
const textCoordinates = {
  britishFrequency: {
    textCoordinates: {
      x: 55,
      y: 205
    },
    text: 'FREQUENCY',
    unit: 'Hz'
  },
  britishDemand: {
    textCoordinates: {
      x: 55,
      y: 213
    },
    text: 'DEMAND',
    unit: ' MW'
  },
  britishWind: {
    textCoordinates: {
      x: 55,
      y: 221
    },
    text: 'WIND',
    unit: ' MW'
  },
  britishSolar: {
    textCoordinates: {
      x: 55,
      y: 229
    },
    text: 'SOLAR',
    unit: ' MW'
  },
  britishCO2Intensity: {
    textCoordinates: {
      x: 55,
      y: 237
    },
    text: 'CO₂ Intensity',
    unit: ' gCO₂/kWh'
  },
  irishFrequency: {
    textCoordinates: {
      x: 14,
      y: 300
    },
    text: 'FREQUENCY',
    unit: 'Hz'
  },
  irishDemand: {
    textCoordinates: {
      x: 14,
      y: 308
    },
    text: 'DEMAND',
    unit: ' MW'
  },
  irishWind: {
    textCoordinates: {
      x: 14,
      y: 316
    },
    unit: ' MW',
    text: 'WIND'
  },
  irishSolar: {
    textCoordinates: {
      x: 14,
      y: 324
    },
    unit: ' MW',
    text: 'SOLAR'
  },
  irishSnsp: {
    textCoordinates: {
      x: 14,
      y: 332
    },
    unit: '%',
    text: 'SNSP'
  },
  irishCO2Intensity: {
    textCoordinates: {
      x: 14,
      y: 340
    },
    unit: ' gCO₂/kWh',
    text: 'CO₂ Intensity'
  },
  europeanFrequency: {
    textCoordinates: {
      x: 244,
      y: 355
    },
    unit: 'Hz',
    text: 'ENTSO-E Freq'
  },
}
export default textCoordinates;
